import React from 'react'

import { useTranslation } from 'react-i18next'

import useFollowLink from './hooks/useFollowLink'

const FollowLink: React.FC = () => {
  const { t } = useTranslation()
  const { following, loading, canFollowSeller, toggleFollowing } = useFollowLink()

  if (!canFollowSeller()) return null
  return (
    <button
      type="button"
      data-testid="follow-btn"
      className="text-md text-orange cursor-pointer hover:underline disabled:hover:no-underline disabled:cursor-not-allowed"
      disabled={loading}
      onClick={toggleFollowing}>
      {following ? t('content.unfollow') : t('content.follow')}
    </button>
  )
}

export default FollowLink
